import { default as indexAYqg5JxdwWMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/index.vue?macro=true";
import { default as completeeFaRoTRpfyMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(auth)/complete.vue?macro=true";
import { default as mobile_45verificationHfgoPyW4ugMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(auth)/mobile-verification.vue?macro=true";
import { default as sign_45ingGvErCeYBIMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(auth)/sign-in.vue?macro=true";
import { default as _91_46_46_46slug_93SbfUKpCJQ7Meta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/[...slug].vue?macro=true";
import { default as _91employee_reference_93rqWpJW9H3eMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/[employee_reference].vue?macro=true";
import { default as confirmRdRYGX6aqEMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/confirm.vue?macro=true";
import { default as finishediLNM5JNOVTMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/finished.vue?macro=true";
import { default as index4arHSs3UIlMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/index.vue?macro=true";
import { default as confirmhuXZnWk13cMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/[booking_id]/confirm.vue?macro=true";
import { default as checkoutYO87zNVi9GMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/checkout.vue?macro=true";
import { default as employeesaNaYKG4gCdMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/employees.vue?macro=true";
import { default as review_45and_45confirmvbQvh8G8EAMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/review-and-confirm.vue?macro=true";
import { default as servicesTJNV8juxqdMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/services.vue?macro=true";
import { default as timeslgvv71mHg5Meta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/times.vue?macro=true";
import { default as checkoutHg0b5Grbw0Meta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/checkout.vue?macro=true";
import { default as finishedCazvHkBKN7Meta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/finished.vue?macro=true";
import { default as indexVUoblH8E7mMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/index.vue?macro=true";
import { default as review_45and_45confirmUVQqE1jaU5Meta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/review-and-confirm.vue?macro=true";
import { default as closeda0auB9JonzMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/closed.vue?macro=true";
import { default as checkout9m4KQ7W82ZMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/checkout.vue?macro=true";
import { default as finished29GWwhZvj7Meta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/finished.vue?macro=true";
import { default as indexjD9fsHcrTXMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/index.vue?macro=true";
import { default as review_45and_45confirmau8gmZgRb6Meta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/review-and-confirm.vue?macro=true";
import { default as indexxtnZQXqmyUMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/index.vue?macro=true";
import { default as checkoutVDgnXnjU3ZMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/checkout.vue?macro=true";
import { default as finishedtN31L1YHMuMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/finished.vue?macro=true";
import { default as index4mlXxrVEjkMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/index.vue?macro=true";
import { default as review_45and_45confirm9Cyje9J4rrMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/review-and-confirm.vue?macro=true";
import { default as _91_46_46_46slug_93NFKY8VzdbDMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/[...slug].vue?macro=true";
import { default as _91id_93YGJPFM8PF2Meta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/[id].vue?macro=true";
import { default as indexvbVdfkRnHQMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/index.vue?macro=true";
import { default as _91slug_93TPAc2wn0HGMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/business-types/[slug].vue?macro=true";
import { default as indexg4XjzjbTx5Meta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/business-types/index.vue?macro=true";
import { default as contact_45sales7x67LzFQzDMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/contact-sales.vue?macro=true";
import { default as contact_45us0jadMLeJYSMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/contact-us.vue?macro=true";
import { default as faqsMazCP24FS1Meta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/faqs.vue?macro=true";
import { default as featureswCryT7O5d4Meta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/features.vue?macro=true";
import { default as privacy_45policygszav6cw2JMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/privacy-policy.vue?macro=true";
import { default as request_45demoqpbBvz36NLMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/request-demo.vue?macro=true";
import { default as bookings8zgxndaTfAMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/bookings.vue?macro=true";
import { default as change_45emailWLNlzTF7guMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/change-email.vue?macro=true";
import { default as change_45mobile4PFz2tyN9RMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/change-mobile.vue?macro=true";
import { default as deletezdpHfZ5JLVMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/delete.vue?macro=true";
import { default as indexNwfU8xR5VQMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/index.vue?macro=true";
import { default as my_45gift_45cardsGXgMsFVQH2Meta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/my-gift-cards.vue?macro=true";
import { default as my_45membershipsltbOZ6TxFgMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/my-memberships.vue?macro=true";
import { default as overdueKhrTAll7VTMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/overdue.vue?macro=true";
import { default as paido0XTAcfmxzMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/paid.vue?macro=true";
import { default as product_45ordersGb85oCymOQMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/product-orders.vue?macro=true";
import { default as settingsYUI0D004kHMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/settings.vue?macro=true";
import { default as visited_45locationsCMoLbTW6XLMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/visited-locations.vue?macro=true";
import { default as walletTFXJIgbvRxMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/wallet.vue?macro=true";
import { default as component_45stubq9nOaU0YViMeta } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@25.0.3_eslint@9.39.2_jiti@2.7.0__ioredis@5.8_ux4w6bd7yb4gnzk34fiubdm3wa/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubq9nOaU0YVi } from "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@25.0.3_eslint@9.39.2_jiti@2.7.0__ioredis@5.8_ux4w6bd7yb4gnzk34fiubdm3wa/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexAYqg5JxdwWMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/index.vue")
  },
  {
    name: "complete___en",
    path: "/en/complete",
    meta: completeeFaRoTRpfyMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(auth)/complete.vue")
  },
  {
    name: "complete___ar",
    path: "/ar/complete",
    meta: completeeFaRoTRpfyMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(auth)/complete.vue")
  },
  {
    name: "mobile-verification___en",
    path: "/en/mobile-verification",
    meta: mobile_45verificationHfgoPyW4ugMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(auth)/mobile-verification.vue")
  },
  {
    name: "mobile-verification___ar",
    path: "/ar/mobile-verification",
    meta: mobile_45verificationHfgoPyW4ugMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(auth)/mobile-verification.vue")
  },
  {
    name: "sign-in___en",
    path: "/en/sign-in",
    meta: sign_45ingGvErCeYBIMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(auth)/sign-in.vue")
  },
  {
    name: "sign-in___ar",
    path: "/ar/sign-in",
    meta: sign_45ingGvErCeYBIMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(auth)/sign-in.vue")
  },
  {
    name: "location_identifier-slug___en",
    path: "/en/:location_identifier()/:slug(.*)*",
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/[...slug].vue")
  },
  {
    name: "location_identifier-slug___ar",
    path: "/ar/:location_identifier()/:slug(.*)*",
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/[...slug].vue")
  },
  {
    name: "location_identifier-employee_reference___en",
    path: "/en/:location_identifier()/:employee_reference()",
    meta: _91employee_reference_93rqWpJW9H3eMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/[employee_reference].vue")
  },
  {
    name: "location_identifier-employee_reference___ar",
    path: "/ar/:location_identifier()/:employee_reference()",
    meta: _91employee_reference_93rqWpJW9H3eMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/[employee_reference].vue")
  },
  {
    name: "location_identifier-b-reference-confirm___en",
    path: "/en/:location_identifier()/b-:reference()/confirm",
    meta: confirmRdRYGX6aqEMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/confirm.vue")
  },
  {
    name: "location_identifier-b-reference-confirm___ar",
    path: "/ar/:location_identifier()/b-:reference()/confirm",
    meta: confirmRdRYGX6aqEMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/confirm.vue")
  },
  {
    name: "location_identifier-b-reference-finished___en",
    path: "/en/:location_identifier()/b-:reference()/finished",
    meta: finishediLNM5JNOVTMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/finished.vue")
  },
  {
    name: "location_identifier-b-reference-finished___ar",
    path: "/ar/:location_identifier()/b-:reference()/finished",
    meta: finishediLNM5JNOVTMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/finished.vue")
  },
  {
    name: "location_identifier-b-reference___en",
    path: "/en/:location_identifier()/b-:reference()",
    meta: index4arHSs3UIlMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/index.vue")
  },
  {
    name: "location_identifier-b-reference___ar",
    path: "/ar/:location_identifier()/b-:reference()",
    meta: index4arHSs3UIlMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/index.vue")
  },
  {
    name: "location_identifier-booking-booking_id-confirm___en",
    path: "/en/:location_identifier()/booking/:booking_id()/confirm",
    meta: confirmhuXZnWk13cMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/[booking_id]/confirm.vue")
  },
  {
    name: "location_identifier-booking-booking_id-confirm___ar",
    path: "/ar/:location_identifier()/booking/:booking_id()/confirm",
    meta: confirmhuXZnWk13cMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/[booking_id]/confirm.vue")
  },
  {
    name: "location_identifier-booking-checkout___en",
    path: "/en/:location_identifier()/booking/checkout",
    meta: checkoutYO87zNVi9GMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/checkout.vue")
  },
  {
    name: "location_identifier-booking-checkout___ar",
    path: "/ar/:location_identifier()/booking/checkout",
    meta: checkoutYO87zNVi9GMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/checkout.vue")
  },
  {
    name: "location_identifier-booking-employees___en",
    path: "/en/:location_identifier()/booking/employees",
    meta: employeesaNaYKG4gCdMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/employees.vue")
  },
  {
    name: "location_identifier-booking-employees___ar",
    path: "/ar/:location_identifier()/booking/employees",
    meta: employeesaNaYKG4gCdMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/employees.vue")
  },
  {
    name: "location_identifier-booking-review-and-confirm___en",
    path: "/en/:location_identifier()/booking/review-and-confirm",
    meta: review_45and_45confirmvbQvh8G8EAMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/review-and-confirm.vue")
  },
  {
    name: "location_identifier-booking-review-and-confirm___ar",
    path: "/ar/:location_identifier()/booking/review-and-confirm",
    meta: review_45and_45confirmvbQvh8G8EAMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/review-and-confirm.vue")
  },
  {
    name: "location_identifier-booking-services___en",
    path: "/en/:location_identifier()/booking/services",
    meta: servicesTJNV8juxqdMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/services.vue")
  },
  {
    name: "location_identifier-booking-services___ar",
    path: "/ar/:location_identifier()/booking/services",
    meta: servicesTJNV8juxqdMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/services.vue")
  },
  {
    name: "location_identifier-booking-times___en",
    path: "/en/:location_identifier()/booking/times",
    meta: timeslgvv71mHg5Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/times.vue")
  },
  {
    name: "location_identifier-booking-times___ar",
    path: "/ar/:location_identifier()/booking/times",
    meta: timeslgvv71mHg5Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/times.vue")
  },
  {
    name: "location_identifier-cart-checkout___en",
    path: "/en/:location_identifier()/cart/checkout",
    meta: checkoutHg0b5Grbw0Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/checkout.vue")
  },
  {
    name: "location_identifier-cart-checkout___ar",
    path: "/ar/:location_identifier()/cart/checkout",
    meta: checkoutHg0b5Grbw0Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/checkout.vue")
  },
  {
    name: "location_identifier-cart-finished___en",
    path: "/en/:location_identifier()/cart/finished",
    meta: finishedCazvHkBKN7Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/finished.vue")
  },
  {
    name: "location_identifier-cart-finished___ar",
    path: "/ar/:location_identifier()/cart/finished",
    meta: finishedCazvHkBKN7Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/finished.vue")
  },
  {
    name: "location_identifier-cart___en",
    path: "/en/:location_identifier()/cart",
    meta: indexVUoblH8E7mMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/index.vue")
  },
  {
    name: "location_identifier-cart___ar",
    path: "/ar/:location_identifier()/cart",
    meta: indexVUoblH8E7mMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/index.vue")
  },
  {
    name: "location_identifier-cart-review-and-confirm___en",
    path: "/en/:location_identifier()/cart/review-and-confirm",
    meta: review_45and_45confirmUVQqE1jaU5Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/review-and-confirm.vue")
  },
  {
    name: "location_identifier-cart-review-and-confirm___ar",
    path: "/ar/:location_identifier()/cart/review-and-confirm",
    meta: review_45and_45confirmUVQqE1jaU5Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/review-and-confirm.vue")
  },
  {
    name: "location_identifier-closed___en",
    path: "/en/:location_identifier()/closed",
    meta: closeda0auB9JonzMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/closed.vue")
  },
  {
    name: "location_identifier-closed___ar",
    path: "/ar/:location_identifier()/closed",
    meta: closeda0auB9JonzMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/closed.vue")
  },
  {
    name: "location_identifier-gift-cards-checkout___en",
    path: "/en/:location_identifier()/gift-cards/checkout",
    meta: checkout9m4KQ7W82ZMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/checkout.vue")
  },
  {
    name: "location_identifier-gift-cards-checkout___ar",
    path: "/ar/:location_identifier()/gift-cards/checkout",
    meta: checkout9m4KQ7W82ZMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/checkout.vue")
  },
  {
    name: "location_identifier-gift-cards-finished___en",
    path: "/en/:location_identifier()/gift-cards/finished",
    meta: finished29GWwhZvj7Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/finished.vue")
  },
  {
    name: "location_identifier-gift-cards-finished___ar",
    path: "/ar/:location_identifier()/gift-cards/finished",
    meta: finished29GWwhZvj7Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/finished.vue")
  },
  {
    name: "location_identifier-gift-cards___en",
    path: "/en/:location_identifier()/gift-cards",
    meta: indexjD9fsHcrTXMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/index.vue")
  },
  {
    name: "location_identifier-gift-cards___ar",
    path: "/ar/:location_identifier()/gift-cards",
    meta: indexjD9fsHcrTXMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/index.vue")
  },
  {
    name: "location_identifier-gift-cards-review-and-confirm___en",
    path: "/en/:location_identifier()/gift-cards/review-and-confirm",
    meta: review_45and_45confirmau8gmZgRb6Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/review-and-confirm.vue")
  },
  {
    name: "location_identifier-gift-cards-review-and-confirm___ar",
    path: "/ar/:location_identifier()/gift-cards/review-and-confirm",
    meta: review_45and_45confirmau8gmZgRb6Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/review-and-confirm.vue")
  },
  {
    name: "location_identifier___en",
    path: "/en/:location_identifier()",
    meta: indexxtnZQXqmyUMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/index.vue")
  },
  {
    name: "location_identifier___ar",
    path: "/ar/:location_identifier()",
    meta: indexxtnZQXqmyUMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/index.vue")
  },
  {
    name: "location_identifier-memberships-checkout___en",
    path: "/en/:location_identifier()/memberships/checkout",
    meta: checkoutVDgnXnjU3ZMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/checkout.vue")
  },
  {
    name: "location_identifier-memberships-checkout___ar",
    path: "/ar/:location_identifier()/memberships/checkout",
    meta: checkoutVDgnXnjU3ZMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/checkout.vue")
  },
  {
    name: "location_identifier-memberships-finished___en",
    path: "/en/:location_identifier()/memberships/finished",
    meta: finishedtN31L1YHMuMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/finished.vue")
  },
  {
    name: "location_identifier-memberships-finished___ar",
    path: "/ar/:location_identifier()/memberships/finished",
    meta: finishedtN31L1YHMuMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/finished.vue")
  },
  {
    name: "location_identifier-memberships___en",
    path: "/en/:location_identifier()/memberships",
    meta: index4mlXxrVEjkMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/index.vue")
  },
  {
    name: "location_identifier-memberships___ar",
    path: "/ar/:location_identifier()/memberships",
    meta: index4mlXxrVEjkMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/index.vue")
  },
  {
    name: "location_identifier-memberships-review-and-confirm___en",
    path: "/en/:location_identifier()/memberships/review-and-confirm",
    meta: review_45and_45confirm9Cyje9J4rrMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/review-and-confirm.vue")
  },
  {
    name: "location_identifier-memberships-review-and-confirm___ar",
    path: "/ar/:location_identifier()/memberships/review-and-confirm",
    meta: review_45and_45confirm9Cyje9J4rrMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/review-and-confirm.vue")
  },
  {
    name: "location_identifier-products-slug___en",
    path: "/en/:location_identifier()/products/:slug(.*)*",
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/[...slug].vue")
  },
  {
    name: "location_identifier-products-slug___ar",
    path: "/ar/:location_identifier()/products/:slug(.*)*",
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/[...slug].vue")
  },
  {
    name: "location_identifier-products-id___en",
    path: "/en/:location_identifier()/products/:id()",
    meta: _91id_93YGJPFM8PF2Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/[id].vue")
  },
  {
    name: "location_identifier-products-id___ar",
    path: "/ar/:location_identifier()/products/:id()",
    meta: _91id_93YGJPFM8PF2Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/[id].vue")
  },
  {
    name: "location_identifier-products___en",
    path: "/en/:location_identifier()/products",
    meta: indexvbVdfkRnHQMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/index.vue")
  },
  {
    name: "location_identifier-products___ar",
    path: "/ar/:location_identifier()/products",
    meta: indexvbVdfkRnHQMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/index.vue")
  },
  {
    name: "business-types-slug___en",
    path: "/en/business-types/:slug()",
    meta: _91slug_93TPAc2wn0HGMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/business-types/[slug].vue")
  },
  {
    name: "business-types-slug___ar",
    path: "/ar/business-types/:slug()",
    meta: _91slug_93TPAc2wn0HGMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/business-types/[slug].vue")
  },
  {
    name: "business-types___en",
    path: "/en/business-types",
    meta: indexg4XjzjbTx5Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/business-types/index.vue")
  },
  {
    name: "business-types___ar",
    path: "/ar/business-types",
    meta: indexg4XjzjbTx5Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/business-types/index.vue")
  },
  {
    name: "contact-sales___en",
    path: "/en/contact-sales",
    meta: contact_45sales7x67LzFQzDMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/contact-sales.vue")
  },
  {
    name: "contact-sales___ar",
    path: "/ar/contact-sales",
    meta: contact_45sales7x67LzFQzDMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/contact-sales.vue")
  },
  {
    name: "contact-us___en",
    path: "/en/contact-us",
    meta: contact_45us0jadMLeJYSMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/contact-us.vue")
  },
  {
    name: "contact-us___ar",
    path: "/ar/contact-us",
    meta: contact_45us0jadMLeJYSMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/contact-us.vue")
  },
  {
    name: "faqs___en",
    path: "/en/faqs",
    meta: faqsMazCP24FS1Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/faqs.vue")
  },
  {
    name: "faqs___ar",
    path: "/ar/faqs",
    meta: faqsMazCP24FS1Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/faqs.vue")
  },
  {
    name: "features___en",
    path: "/en/features",
    meta: featureswCryT7O5d4Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/features.vue")
  },
  {
    name: "features___ar",
    path: "/ar/features",
    meta: featureswCryT7O5d4Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/features.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexAYqg5JxdwWMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: indexAYqg5JxdwWMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/index.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    meta: privacy_45policygszav6cw2JMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ar",
    path: "/ar/privacy-policy",
    meta: privacy_45policygszav6cw2JMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/privacy-policy.vue")
  },
  {
    name: "request-demo___en",
    path: "/en/request-demo",
    meta: request_45demoqpbBvz36NLMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/request-demo.vue")
  },
  {
    name: "request-demo___ar",
    path: "/ar/request-demo",
    meta: request_45demoqpbBvz36NLMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/(website)/request-demo.vue")
  },
  {
    name: "account-bookings___en",
    path: "/en/account/bookings",
    meta: bookings8zgxndaTfAMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/bookings.vue")
  },
  {
    name: "account-bookings___ar",
    path: "/ar/account/bookings",
    meta: bookings8zgxndaTfAMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/bookings.vue")
  },
  {
    name: "account-change-email___en",
    path: "/en/account/change-email",
    meta: change_45emailWLNlzTF7guMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/change-email.vue")
  },
  {
    name: "account-change-email___ar",
    path: "/ar/account/change-email",
    meta: change_45emailWLNlzTF7guMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/change-email.vue")
  },
  {
    name: "account-change-mobile___en",
    path: "/en/account/change-mobile",
    meta: change_45mobile4PFz2tyN9RMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/change-mobile.vue")
  },
  {
    name: "account-change-mobile___ar",
    path: "/ar/account/change-mobile",
    meta: change_45mobile4PFz2tyN9RMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/change-mobile.vue")
  },
  {
    name: "account-delete___en",
    path: "/en/account/delete",
    meta: deletezdpHfZ5JLVMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/delete.vue")
  },
  {
    name: "account-delete___ar",
    path: "/ar/account/delete",
    meta: deletezdpHfZ5JLVMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/delete.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    meta: indexNwfU8xR5VQMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/index.vue")
  },
  {
    name: "account___ar",
    path: "/ar/account",
    meta: indexNwfU8xR5VQMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/index.vue")
  },
  {
    name: "account-my-gift-cards___en",
    path: "/en/account/my-gift-cards",
    meta: my_45gift_45cardsGXgMsFVQH2Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/my-gift-cards.vue")
  },
  {
    name: "account-my-gift-cards___ar",
    path: "/ar/account/my-gift-cards",
    meta: my_45gift_45cardsGXgMsFVQH2Meta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/my-gift-cards.vue")
  },
  {
    name: "account-my-memberships___en",
    path: "/en/account/my-memberships",
    meta: my_45membershipsltbOZ6TxFgMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/my-memberships.vue")
  },
  {
    name: "account-my-memberships___ar",
    path: "/ar/account/my-memberships",
    meta: my_45membershipsltbOZ6TxFgMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/my-memberships.vue")
  },
  {
    name: "account-overdue___en",
    path: "/en/account/overdue",
    meta: overdueKhrTAll7VTMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/overdue.vue")
  },
  {
    name: "account-overdue___ar",
    path: "/ar/account/overdue",
    meta: overdueKhrTAll7VTMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/overdue.vue")
  },
  {
    name: "account-paid___en",
    path: "/en/account/paid",
    meta: paido0XTAcfmxzMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/paid.vue")
  },
  {
    name: "account-paid___ar",
    path: "/ar/account/paid",
    meta: paido0XTAcfmxzMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/paid.vue")
  },
  {
    name: "account-product-orders___en",
    path: "/en/account/product-orders",
    meta: product_45ordersGb85oCymOQMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/product-orders.vue")
  },
  {
    name: "account-product-orders___ar",
    path: "/ar/account/product-orders",
    meta: product_45ordersGb85oCymOQMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/product-orders.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account/settings",
    meta: settingsYUI0D004kHMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/settings.vue")
  },
  {
    name: "account-settings___ar",
    path: "/ar/account/settings",
    meta: settingsYUI0D004kHMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/settings.vue")
  },
  {
    name: "account-visited-locations___en",
    path: "/en/account/visited-locations",
    meta: visited_45locationsCMoLbTW6XLMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/visited-locations.vue")
  },
  {
    name: "account-visited-locations___ar",
    path: "/ar/account/visited-locations",
    meta: visited_45locationsCMoLbTW6XLMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/visited-locations.vue")
  },
  {
    name: "account-wallet___en",
    path: "/en/account/wallet",
    meta: walletTFXJIgbvRxMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/wallet.vue")
  },
  {
    name: "account-wallet___ar",
    path: "/ar/account/wallet",
    meta: walletTFXJIgbvRxMeta || {},
    component: () => import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/pages/account/wallet.vue")
  },
  {
    name: component_45stubq9nOaU0YViMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubq9nOaU0YVi
  }
]